// extracted by mini-css-extract-plugin
module.exports = {"sidebarWrapper":"sidebar-module--sidebarWrapper--12c_M","sidebarWrapper2":"sidebar-module--sidebarWrapper2--3rANw"};